import axios from "axios";

export default {
    namespaced: true,
    state: {
        stats: null,
    },
    mutations: {
        setStats(state, payload) {
            state.stats = payload;
        },
    },
    getters: {
        getStats: function (state) {
            return state.stats;
        },
    },
    actions: {
        async getMetadataStats(ctx) {
            return axios
                .get(`/api/v1/storage/me/stats`)
                .then((res) => {
                    if (res.status === 200) {
                        let stats = res.data;
                        stats.rate = ((stats.used / stats.max) * 100).toFixed(2);
                        ctx.commit("setStats", stats);
                    } else {
                        ctx.commit("setStats", null);
                    }
                    return res;
                })
                .catch((err) => {
                    console.log("Fail to query data stats", err);
                });
        },
        async getSelfFiles(ctx, { start, size }) {
            return axios.get("/api/v1/storage/me/files", {
                params: {
                    start,
                    size,
                },
            });
        },
        async getFileById(ctx, { fileId }) {
            return axios.get(`/api/v1/storage/files/${fileId}`);
        },
        // deprecated API
        // async uploadFile(ctx, { file, name, config }) {
        //     let form = new FormData();
        //     form.append("file", file);
        //     form.append("name", name);

        //     return axios(
        //         Object.assign(
        //             {
        //                 url: "/api/v1/storage/me/files",
        //                 method: "put",
        //                 data: form,
        //                 headers: { "Content-Type": "multipart/form-data" },
        //             },
        //             config || {}
        //         )
        //     );
        // },
        async deleteFile(ctx, { file }) {
            return axios.delete(`/api/v1/storage/me/files/${file}`);
        },
        async uploadMultipleFiles(ctx, { request, config }) {
            return axios(
                Object.assign(
                    {
                        url: "/api/v1/storage/me/files/multi",
                        method: "post",
                        data: request,
                        headers: { "Content-Type": "multipart/form-data" },
                    },
                    config || {}
                )
            );
        },
    },
};
